import React from "react"
import Masonry from "react-masonry-css";
import ProductCard from "../ProductCard";

const MasonryProductList = ({data}) => {
    return (
        <Masonry style={{ display: "flex", width: "auto" }}>
        {data?.map((item) => {
            const { imageUrl, title, description } = item;
            return (
                <ProductCard
                    cardContentTitle={title}
                    cardMediaTitle={title}
                    cardItemDes={description}
                    relativeImage={imageUrl}
                    elevation={2}
                />
            );
        })}
    </Masonry>

    )
}

export default MasonryProductList